module.exports = __webpack_public_path__ + "img/diapositiva-2.a4092d53.png";